import { Divider } from '@eneco/sparky';

import type { FormFieldComponent } from './types';

/** A rule between form sections. Has no content and contributes no validation, so it declares no `formSchema`. */
const GenericFormDivider: FormFieldComponent = () => {
  // TODO: emphasis and weight should probably be configurable at some point
  return <Divider emphasis="low" weight="regular" />;
};

export default GenericFormDivider;
